export default __webpack_public_path__ + "static/media/FP.ee8f3b7f.png";